'use client';

import React from 'react';
import styled from 'styled-components';
import { isMapSelector } from '@/app/common/css/selectors.ts';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';

const ExternalHeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  bottom: unset;

  ${isMapSelector} & {
    @media (max-width: 1023px) {
      z-index: 2;
    }
  }
`;

const ExternalHeader = ({ externalHeaderHTML }: { externalHeaderHTML: string | null }) => (
  <ErrorBoundary id="ExternalHeader">
    <ExternalHeaderContainer
      data-testid="external-header"
      dangerouslySetInnerHTML={{ __html: externalHeaderHTML || '' }}
    />
  </ErrorBoundary>
);

export default ExternalHeader;
